<template>
    <div :id="App.root_activated_view" class="main_view_container">
        <transition name="fade">
            <view_dashboard
                v-if="App.root_activated_view === 'dashboard'"
            ></view_dashboard>
        </transition>
        <transition name="fade">
            <view_must_login
                v-if="App.root_activated_view === 'must_login'"
            ></view_must_login>
        </transition>
        <transition name="fade">
            <view_query_filters
                v-if="App.root_activated_view === 'query_filters'"
            ></view_query_filters>
        </transition>
        <transition name="fade">
            <view_application_solutions
                v-if="
                    App.root_activated_view ===
                    'application_solutions'
                "
            ></view_application_solutions>
        </transition>
        <transition name="fade">
            <view_single_application_solution
                class="view_single_application"
                v-if="
                    App.root_activated_view ===
                    'single_application_solution'
                "
            ></view_single_application_solution>
        </transition>
    </div>
</template>

<script>
import App from './../application'
import view_dashboard from "./view_dashboard.vue"
import view_must_login from './view_must_login.vue'
import view_query_filters from './view_query_filters.vue'
import view_application_solutions from './view_application_solutions.vue'
import view_single_application_solution from './view_single_application_solution.vue'
export default {
    components:{
        view_dashboard,
        view_must_login,
        view_query_filters,
        view_application_solutions,
        view_single_application_solution
    },

    data: function(){
        return {
            App: App
        }
    }
}
</script>

<style>

</style>